<div class="section">
    <app-segobjectpropertymap-panel></app-segobjectpropertymap-panel>
    <app-saved-hierarchical-selection-roots></app-saved-hierarchical-selection-roots>
</div>
<ng-container
    *ngrxLet="currentHierarchicalSelectionRootName$ as currentHierarchicalSelectionRootName"
>
    <div [hidden]="currentHierarchicalSelectionRootName == undefined">
        <div class="section">
            <app-saved-hierarchical-selection-nodes></app-saved-hierarchical-selection-nodes>
        </div>
        <div class="section scroll">
            <app-plot-data-selection></app-plot-data-selection>
            <app-selection-manipulation></app-selection-manipulation>
            <app-scatter-plot></app-scatter-plot>
        </div>
        <div [hidden]="currentHierarchicalSelectionRootName != undefined">
            <div class="section default-text">
                No hierarchical selection root chosen or created.
            </div>
        </div>
        <div
            class="section default-text"
            *ngIf="
                isUnsupervisedSelection &&
                currentHierarchicalSelectionRootName != undefined &&
                cellTypeDetectionResults
            "
        >
            <div *ngFor="let cellTypeDetectionResult of cellTypeDetectionResults">
                <div>
                    <label>{{ cellTypeDetectionResult?.name }}</label>
                    <button
                        (click)="downloadData(cellTypeDetectionResult)"
                        class="icon-button"
                        [attr.aria-label]="'Download data'"
                        [title]="'Download data'"
                    >
                        <cds-icon shape="download"></cds-icon>
                    </button>
                </div>
                <img
                    [src]="getImageUrl(cellTypeDetectionResult)"
                    (click)="openImage(getImageUrl(cellTypeDetectionResult))"
                />
            </div>
        </div>
    </div>
    <div *ngIf="isUnsupervisedSelection">
        <app-auto-cell-detect></app-auto-cell-detect>
    </div>
</ng-container>
